function escapeHtml(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const RE_NEGRITA_SEGMENTO = /(\*\*([^*]+)\*\*|__([^_]+)__)/g;

/**
 * Limpia espacios dentro de **...** / __...__ y asegura un espacio
 * cuando el marcador queda pegado a una letra (sin romper cierres).
 */
export function normalizarMarcadoresNegrita(texto) {
  if (!texto) return '';

  const partes = [];
  let conPlaceholders = String(texto).replace(RE_NEGRITA_SEGMENTO, (_, _full, estrellas, guiones) => {
    const crudo = estrellas != null ? estrellas : guiones;
    const inner = String(crudo).replace(/\s+/g, ' ').trim();
    if (!inner) return '';
    const idx = partes.length;
    partes.push({ tipo: estrellas != null ? '**' : '__', inner });
    return `\u0000B${idx}\u0000`;
  });

  // Espacio si un marcador queda pegado a letras (ya es seguro: placeholders)
  conPlaceholders = conPlaceholders.replace(/(\p{L})(\u0000B\d+\u0000)/gu, '$1 $2');
  conPlaceholders = conPlaceholders.replace(/(\u0000B\d+\u0000)(\p{L})/gu, '$1 $2');

  return conPlaceholders.replace(/\u0000B(\d+)\u0000/g, (_, idx) => {
    const parte = partes[Number(idx)];
    if (!parte) return '';
    return `${parte.tipo}${parte.inner}${parte.tipo}`;
  });
}

/**
 * Convierte marcadores de negrita a HTML seguro.
 * Sintaxis: **texto** o __texto__
 * Tolera espacios internos (** texto **) y negrita en varias líneas.
 */
export function textoContratoAHtml(texto) {
  if (!texto) return '';

  const partes = String(texto).split(/(\*\*[^*]+?\*\*|__[^_]+?__)/g);

  return partes
    .map((parte) => {
      if (/^\*\*[\s\S]+\*\*$/.test(parte)) {
        const inner = parte.slice(2, -2);
        const trimmed = inner.replace(/\s+/g, ' ').trim();
        const lead = (inner.match(/^\s*/) || [''])[0];
        const trail = (inner.match(/\s*$/) || [''])[0];
        // Espacios fuera del <strong> para no “engordar” el glifo tipográfico
        return `${escapeHtml(lead)}<strong>${escapeHtml(trimmed)}</strong>${escapeHtml(trail)}`;
      }
      if (/^__[\s\S]+__$/.test(parte)) {
        const inner = parte.slice(2, -2);
        const trimmed = inner.replace(/\s+/g, ' ').trim();
        const lead = (inner.match(/^\s*/) || [''])[0];
        const trail = (inner.match(/\s*$/) || [''])[0];
        return `${escapeHtml(lead)}<strong>${escapeHtml(trimmed)}</strong>${escapeHtml(trail)}`;
      }
      return escapeHtml(parte).replace(/\n/g, '<br/>');
    })
    .join('');
}

/** Envuelve la selección del textarea con ** para negrita. */
export function envolverSeleccionNegrita(texto, inicio, fin) {
  const contenido = texto || '';
  const start = inicio ?? contenido.length;
  const end = fin ?? start;
  const seleccion = contenido.slice(start, end);

  if (seleccion) {
    // Espacios extremos fuera del marcador para que coincida editor y vista previa
    const lead = (seleccion.match(/^\s*/) || [''])[0];
    const trail = (seleccion.match(/\s*$/) || [''])[0];
    const nucleo = seleccion.slice(lead.length, seleccion.length - trail.length);
    const bloque = nucleo ? `${lead}**${nucleo}**${trail}` : `**${seleccion}**`;
    return {
      texto: contenido.slice(0, start) + bloque + contenido.slice(end),
      cursorInicio: start + lead.length + 2,
      cursorFin: start + lead.length + 2 + (nucleo ? nucleo.length : seleccion.length),
    };
  }

  const token = '**texto**';
  return {
    texto: contenido.slice(0, start) + token + contenido.slice(end),
    cursorInicio: start + 2,
    cursorFin: start + 6,
  };
}

export function aplicarNegritaEnTextarea(textarea, setTexto) {
  if (!textarea) return;

  const inicio = textarea.selectionStart ?? 0;
  const fin = textarea.selectionEnd ?? inicio;
  const { texto, cursorInicio, cursorFin } = envolverSeleccionNegrita(
    textarea.value,
    inicio,
    fin
  );

  setTexto(texto);

  requestAnimationFrame(() => {
    textarea.focus();
    textarea.setSelectionRange(cursorInicio, cursorFin);
  });
}
